/**
 * @module  color-manipulate
 */

module.exports = {
	lighten: require('./lighten'),
	darken: require('./darken'),
	saturate: require('./saturate'),
	desaturate: require('./desaturate'),
	whiten: require('./whiten'),
	blacken: require('./blacken'),
	fadein: require('./fadein'),
	fadeout: require('./fadeout'),
	invert: require('./invert'),
	grayscale: require('./grayscale'),
	spin: require('./spin'),
	mix: require('./mix')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-manipulate/index.js
// module id = 4rKL
// module chunks = 0